'use client';

import { useState } from 'react';
import {
  Alert,
  Anchor,
  Button,
  Container,
  Divider,
  Group,
  Input,
  Text,
  Title,
} from '@mantine/core';
import { isEmail, useForm } from '@mantine/form';
import { forgotPasswordAction } from '@/app/actions/auth';

/** Add server component and/or api route to validate the email
 * a valid email in the database before sending the reset email
 */
export default function ForgotPassword({
  searchParams,
}: {
  searchParams: { success?: string; error?: string };
}) {
  const form = useForm({
    initialValues: {
      email: '',
      callbackUrl: null,
    },
    validate: {
      email: isEmail('Invalid email address'),
    },
  });

  const handleSubmit = async (values: typeof form.values) => {
    if (form.validate()) {
      await forgotPasswordAction(values);
    }
  };

  return (
    <Container size={'xs'}>
      <Title mt="xl" order={1} fw={150}>
        Forgot password
      </Title>
      <Divider my="sm" />
      <form
        onSubmit={form.onSubmit(handleSubmit)}
        style={{ display: 'flex', flexDirection: 'column', gap: 'md' }}
      >
        <Group>
          <Text size="sm" c="dimmed">
            Already have an account? <Anchor href="/sign-in">Sign in</Anchor>
          </Text>
        </Group>
        <Input.Wrapper label="Email" required>
          <Input {...form.getInputProps('email')} placeholder="you@example.com" required />
        </Input.Wrapper>
        {form.errors.email && (
          <Alert variant="light" color="red" mt={10} title={form.errors.email} />
        )}
        {searchParams.success && (
          <Alert variant="light" mt="md" title={'Password Recovery Email Sent'} />
        )}
        {searchParams.error && <Alert color="red" mt="md" title={searchParams.error} />}
        <Button type="submit" mt={12} maw={150}>
          Send reset email
        </Button>
      </form>
    </Container>
  );
}
